export default __webpack_public_path__ + "static/media/tab02_title01.42f4e46b.png";